export class FilteredData
{
    Filter_StartDate: Date;
    Filter_EndDate: Date;
    Filter_InstanceId: number;
    Filter_ResourceId: number; 
    Filter_JobId: number
}